function getChatRequestState() {
    if (!window.__chatRequestState) {
        window.__chatRequestState = {
            activeRequestId: 0,
            isResponding: false,
        };
    }

    return window.__chatRequestState;
}

window.startChatRequest = function () {
    const state = getChatRequestState();

    state.activeRequestId += 1;
    state.isResponding = true;

    return state.activeRequestId;
};

window.finishChatRequest = function (requestId = null) {
    const state = getChatRequestState();

    if (requestId !== null && state.activeRequestId !== requestId) {
        return false;
    }

    state.isResponding = false;
    return true;
};

window.cancelChatRequest = function () {
    const state = getChatRequestState();

    state.activeRequestId += 1;
    state.isResponding = false;

    return state.activeRequestId;
};

window.isCurrentChatRequest = function (requestId) {
    const state = getChatRequestState();

    return requestId !== null && state.activeRequestId === requestId;
};

window.isChatRequestInProgress = function () {
    return getChatRequestState().isResponding;
};

window.stopChatPlayback = function () {
    if (typeof window.stopTextToSpeechPlayback === "function") {
        window.stopTextToSpeechPlayback();
    } else {
        const audioElement = document.getElementById("audioPlayer");
        if (audioElement) {
            try {
                audioElement.pause();
            } catch (error) {}

            audioElement.removeAttribute("src");
            audioElement.load();
        }
    }

    if (typeof window.stopDidPlayback === "function") {
        window.stopDidPlayback();
    }
};

window.stopAllChatActions = function () {
    window.cancelChatRequest();

    if (typeof window.stopOpenAIStream === "function") {
        window.stopOpenAIStream();
    }

    if (typeof window.stopOpenAIRequest === "function") {
        window.stopOpenAIRequest();
    }

    if (typeof window.stopRecognition === "function") {
        window.stopRecognition();
    }

    if (typeof window.stopDidStreaming === "function") {
        window.stopDidStreaming();
    } else {
        window.stopChatPlayback();
    }

    if (typeof window.enableButton === "function") {
        window.enableButton();
    } else {
        $(".chat-tool").removeClass("disable").find("button").prop("disabled", false);
    }

    $("#rd-loading, #rd-reconnecting-loading, #rd-process-voice, #rd-setting-voice-pop, .rd-loading-content").hide();
    $('meta[name="use-voice"]').attr("content", 0);
};

$(function () {
    $(document).on("click", "#rd-stop-stream", function () {
        window.stopChatPlayback();
    });

    $(document).on("click", "#rd-stop", function () {
        window.stopAllChatActions();
    });
});

